import { actionTypesEnum } from '../enum';

export const localFormReducer = (state = null, action) => {

    if (action.type === actionTypesEnum.localForm) {
        return action.payload;
    }

    return state;
}

// export const localFormSalvandoReducer = (state = null, action) => {

//     if (action.type === actionTypesEnum.localFormSalvando) {
//         return action.payload;
//     }

//     return state;
// }